<template>
  <el-dialog title="业务板块管理" :visible.sync="currentValue" width="auto" custom-class="business-unit" top="0" append-to-body @open="open" @close="close">
    <div class="business-unit-content" v-loading="loading">
      <div class="left">
        <div class="tip">团队</div>
        <div class="item bgActive" v-for="item in departmentProjectFolderList" :key="item.department_category_id" @click="check(item)" :class="{'active': active === item.department_category_id}">{{item.name}}</div>
      </div>
      <div class="right">
        <div class="list" ref="list">
          <div class="tip">业务板块</div>
          <vuedraggable class="tree-element" handle=".move-icon" element="div" v-bind="dragOptions()" @update="end" @add="end" :list="activeChildren.visible">
            <template v-for="(item) in activeChildren.visible">
              <div class="item bgActive" :key="item.project_list_id" :class="{'hidden-cell': !item.active}">
                <i class="icon iconfont iconicon_drag_order move-icon"></i>
                <toolTip :title="item.title" maxWidth="auto">{{item.title}}</toolTip>
                <span class="hideOrVisible letterHover" @click="trigger(item)">隐藏</span>
              </div>
            </template>
          </vuedraggable>
          <div class="line" v-if="activeChildren.hide && activeChildren.hide.length > 0"></div>
          <template v-for="(item) in activeChildren.hide">
            <div class="item bgActive" :key="item.project_list_id" :class="{'hidden-cell': !item.active}">
              <i class="icon iconfont iconicon_drag_order move-icon"></i>
              <toolTip :title="item.title" maxWidth="auto">{{item.title}}</toolTip>
              <span class="hideOrVisible letterHover" @click="trigger(item)">显示</span>
            </div>
          </template>
        </div>
        <div class="btn">
          <span class="text-blue" @click="showDialog = true"><i class="icon iconfont iconicon_input"></i>编辑业务板块</span>
        </div>
      </div>
    </div>
    <Dialog v-model="showDialog" @change="dialogDataChange"></Dialog>
  </el-dialog>
</template>
<script>
import Api from '@/services/api/systemSetting/systemSetting'
import vuedraggable from 'vuedraggable'
import Dialog from './dialog'
export default {
  props:['value'],
  components: {
    vuedraggable,
    Dialog
  },
  data() {
    return {
      departmentProjectFolderList: [],
      active: -1,
      activeChildren: {
        visible: [],
        hide: []
      },
      loading: false,
      showDialog: false
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
  },
  watch: {
    active() {
      let item = this.departmentProjectFolderList.find(res => res.department_category_id === this.active)
      this.activeChildren = item ? item.projectList : {}
      this.$nextTick(() => {
        this.$refs.list ? this.$refs.list.scrollTop = 0 : ''
      })
    }
  },
  created() {

  },
  methods: {
    close() {
      this.isChange ? this.$emit('businessChange') : ''
    },
    async open() {
      this.init()
      await this.fetchProjectFolderList()
      this.active = this.departmentProjectFolderList[0] ? this.departmentProjectFolderList[0].department_category_id : -1
    },
    async dialogDataChange() {
      this.loading = true
      let ac = this.active
      this.init()
      await this.fetchProjectFolderList()
      this.$nextTick(() => {
        this.active = ac
        this.isChange = true
      })
    },
    init() {
      this.departmentProjectFolderList = []
      this.active = -1
      this.activeChildren = {
        visible: [],
        hide: []
      }
      this.loading = false
      this.isChange = false
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'list',
      }
    },
    async fetchProjectFolderList() {
      this.loading = true
      let result = await Api.getDepartmentProjectFolderList()
      this.departmentProjectFolderList = result
      this.departmentProjectFolderList.map(item => {
        item.projectList = this.groupData(item.projectList)
      })
      this.loading = false
    },
    groupData(data) {
      let arr_1 = [];
      let arr_0 = [];
      data.forEach((item) => {
        if (item.active) {
          arr_1.push(item)
        } else {
          arr_0.push(item)
        }
      })
      return {
        visible: arr_1,
        hide: arr_0
      }
    },
    check(val) {
      this.active = val.department_category_id
    },
    end() {
      let arr = [...this.activeChildren.visible, ...this.activeChildren.hide]
      let list = arr.map((res, index) => {
        return {
          project_list_id: res.project_list_id,
          orderby: arr.length - index
        }
      })
      Api.updateDepartmentProjectFolderOrderby({
        department_category_id: this.active,
        list
      })
      this.isChange = true
    },
    async trigger(itemData) {
      await Api.updateDepartmentProjectFolder({
        'project_list_id': itemData.project_list_id,  //必填
        'department_category_id': itemData.department_category_id,  //必填
        'active': !itemData.active - 0  //非必填
      })
      this.active = -1
      await this.fetchProjectFolderList()
      this.active = itemData.department_category_id
      this.isChange = true
    },
  }
}
</script>
<style lang="scss">
.business-unit {
  top: 50%;
  transform: translate(0, -50%);
  .el-dialog__header {
    padding: 15px 24px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
  }
  .el-dialog__headerbtn {
    top: 15px;
  }
  .el-dialog__body {
    padding: 0;
  }
  .business-unit-content {
    display: flex;
    height: 741px;
    .left {
      width: 300px;
      flex-shrink: 0;
      padding: 16px 24px;
      box-sizing: border-box;
      border-right: 1px solid rgba(32,32,32,0.08);
      height: 100%;
      overflow-x: hidden;
      overflow-y: overlay;
    }
    .right {
      width: 700px;
      height: 100%;
      flex-shrink: 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .item,.tip {
        margin: 0 24px;
      }
      .item {
        padding-left: 38px;
        position: relative;
        display: flex;
        justify-content: space-between;
        &:hover {
          .move-icon {
            visibility: visible;
          }
          .hideOrVisible {
            visibility: visible;
          }
        }
        .tool-tip {
          width: 0;
          flex: 1;
        }
      }
      .move-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translate(0, -50%);
        color: rgba(32, 32, 32, 0.4);
        font-size: 14px;
        visibility: hidden;
      }
      .hideOrVisible {
        font-size: 14px;
        visibility: hidden;
      }
    }
    .tip, .item {
      height: 48px;
      display: flex;
      align-items: center;
      padding: 0 16px;
      border-radius: 4px;
      flex-shrink: 0;
    }
    .tip {
      color: rgba(32, 32, 32, 0.6);
      font-size: 14px;
    }
    .btn {
      height: 54px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(32, 32, 32, 0.8);
      font-size: 14px;
      border-top: 1px solid rgba(32, 32, 32, 0.08);
      box-sizing: border-box;
      i {
        margin-right: 8px;
        font-size: 14px;
      }
    }
    .list {
      display: flex;
      flex-direction: column;
      height: 0;
      flex: 1;
      overflow-x: hidden;
      overflow-y: overlay;
      padding: 16px 0;
      .tip {
        padding-left: 38px;
      }
    }
    .line {
      border-top: 1px solid rgba(32,32,32,0.04);
      margin: 16px 24px;
    }
    .hidden-cell {
      color: rgba(32, 32, 32, 0.6);
    }
    .active {
      background-color: rgba(32, 32, 32, 0.08);
    }
  }
}
</style>
